import { Amount } from "@/components";
import * as Domain from "@/domain";
import { colors } from "@/styles/colors";
import { Icon, Progress } from "@/ui";
import format from "date-fns/format";
import parse from "date-fns/parse";
import { FunctionComponent, ReactElement, useCallback } from "react";
import styles from "./Debt.module.scss";
import { IDebtProps } from "./types";

export const Debt: FunctionComponent<IDebtProps> = (
  props: IDebtProps
): ReactElement<IDebtProps> => {
  const { debt, onPress, ...restProps } = props;

  const doPress = useCallback(() => {
    onPress(debt);
  }, [debt, onPress]);

  return (
    <div className="col-lg-12 col-md-6 col-sm-6 bigCardCol" {...restProps}>
      <div className="card bigCard mainBlockBg" onClick={doPress}>
        <div className="smallCard">
          <Icon
            backgroundColor={debt.color}
            className={styles.iconDefault}
            color={colors.palette.white}
            icon={debt.icon}
            size={32}
          />
          <div className="cardContent">
            <Amount
              className="cardContentValue"
              currency={debt.currency}
              value={debt.balance}
            />
          </div>
        </div>
        <ul className="debt">
          <li className="debtLi">
            <span>Выплачено:</span>
            <Amount currency={debt.currency} value={debt.balance} />
          </li>
          <li className="debtLi">
            <span>Осталось:</span>
            <Amount
              currency={debt.currency}
              value={(debt.limitation || 0) - (debt.balance || 0)}
            />
          </li>
          {debt.deadlineAt && (
            <li className="debtLi">
              <span>Вернуть до:</span>
              <span>
                {format(
                  parse(debt.deadlineAt, "yyyy-MM-dd", new Date()),
                  "dd.MM.yyyy"
                )}
              </span>
            </li>
          )}
        </ul>
        <Progress.Bar
          backgroundColor={Domain.Color.schemas[debt.color].lightBackground}
          color={debt.color}
          total={debt.limitation}
          value={debt.balance}
        />
        <span className="bigCardLabel">{debt.name}</span>
      </div>
    </div>
  );
};
